import type { CalendarNode } from '@/components_deprecated'
import { Calendar } from '@/components_deprecated'
import {
  eachDayOfInterval,
  isSameDay,
  isWithinInterval,
  parseISO,
  subMilliseconds,
} from 'date-fns'
import type { MouseEvent } from 'react'
import { useState } from 'react'
import { usePopper } from 'react-popper'
import {
  AbsenceCalendarPopup,
  OuterPopupWrapper as PopupWrapper,
} from './AbsenceCalendarPopup'
import type { AbsenceNode } from './absences-table'

export interface AbsencesCalendarProps {
  startDate: Date
  endDate: Date

  absences: AbsenceNode[]
}

export const AbsencesCalendar: React.FC<AbsencesCalendarProps> = ({
  startDate,
  endDate,
  absences,
}) => {
  const [popupAbsence, setPopupAbsence] = useState<AbsenceNode | null>(null)
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null)
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null
  )
  const { styles, attributes } = usePopper(referenceElement, popperElement)

  const calendarDates = eachDayOfInterval({ start: startDate, end: endDate })

  function handleClick(
    evt: MouseEvent<HTMLDivElement, globalThis.MouseEvent>,
    absence: AbsenceNode
  ) {
    setPopupAbsence(absence)
    setReferenceElement(evt.currentTarget)
  }

  const calendarData = calendarDates.map(date => ({
    date: date,
    nodes: absences.reduce<CalendarNode[]>((acc, cur) => {
      const adjustedEndDate = subMilliseconds(parseISO(cur.datetimeStart), 1)
      const isInRange =
        isWithinInterval(date, {
          start: parseISO(cur.datetimeStart),
          end: parseISO(cur.datetimeEnd),
        }) ||
        isSameDay(date, parseISO(cur.datetimeStart)) ||
        isSameDay(date, adjustedEndDate)

      if (isInRange)
        acc.push({
          id: cur.id,
          text: cur.user.fullName,
          color: cur.absenceType?.color ?? 'Unknown',
          onClick: (evt: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) =>
            handleClick(evt, cur),
        })

      return acc
    }, []),
  }))

  return (
    <>
      <Calendar data={calendarData} />

      {popupAbsence && (
        <PopupWrapper
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
        >
          <AbsenceCalendarPopup
            absence={popupAbsence}
            onClickOutside={() => setPopupAbsence(null)}
          />
        </PopupWrapper>
      )}
    </>
  )
}
